import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PublicRoute from '../routes/PublicRoute';
import PrivateRoute from '../routes/PrivateRoute';
import { LoginForm } from '../../features/auth';
import { Companies } from '../../features/company';
import Drive from '../../features/drive/components/drive';
import { Users } from '../../features/user';
import { useSelector } from 'react-redux';
import { selectAuthUser } from '../../features/auth';
import DriveDashboard from '../../features/dashboard/components/DriveDashboard';
import PasswordSetupPage from '../../features/auth/components/PasswordSetup';
import ForgotPasswordPage from '../../features/auth/components/ForgotPassword';
import Collection from '../../features/collection/components/Collections';
import LaneMapView from '../../features/lane/components/LaneMapView';
import LaneMarkingPage from '../../features/lane/components/LaneMarkingPage';
import RailsMarkingPage from '../../features/rails/Components/RailsMarkingPage';
import GodViewMap from '../../features/layout/GodViewMaps';

export const RouteProvider = () => {
  const user = useSelector(selectAuthUser);

  return (
    <Router>
      <Routes>
        <Route element={<PublicRoute />}>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/reset" element={<PasswordSetupPage />} />
          <Route path="/forgot" element={<ForgotPasswordPage />} />
        </Route>
        <Route element={<PrivateRoute />}>
          <Route
            path="/"
            element={
              user?.rolename.includes('Rieker') || user?.rolename === 'Manager' ? (
                <Companies />
              ) : (
                <Collection />
              )
            }
          />
          <Route path="/drives" element={<Drive />} />
          <Route path="/collections" element={<Collection />} />
          <Route path="/users" element={<Users />} />
          <Route path="/dashboard" element={<DriveDashboard />} />
          <Route path="/lane-map/:driveId" element={<LaneMapView />} />
          <Route path="/lane-marking/:driveId" element={<LaneMarkingPage />} />
          <Route path="/rails-marking/:driveId" element={<RailsMarkingPage />} />
          <Route path="/god" element={<GodViewMap />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};
